import { define } from 'wicked-elements'
import * as widont from 'widont'

define('[data-component~="widont"]', {
  init() {
    const words = this.element.innerText.trim().split(' ')
    const wordCount = words.length
    const letterCountOfLast = words.slice(-1).join('').length
    const letterCountOfLastTwo = words.slice(-2).join('').length
    if (wordCount > 3 && letterCountOfLastTwo < 16 && letterCountOfLast < 12) {
      this.element.innerHTML = widont(this.element.innerHTML)
    }
  },
})
